import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFileLines,
  faFileCirclePlus,
} from "@fortawesome/free-solid-svg-icons"

/**
 * Component displayed when no dashboard is selected but project data is available.
 *
 * Provides visual feedback and guidance to users on how to proceed with
 * either selecting an existing dashboard or creating a new one.
 *
 * Features:
 * - Centered layout with icon and messaging
 * - Responsive design for different screen sizes
 * - Clear call-to-action guidance
 * - Accessible design with proper contrast and spacing
 */
const NoReportSelected: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center flex-grow p-8">
      <div className="text-center max-w-md">
        <FontAwesomeIcon
          icon={faFileLines}
          className="text-6xl text-gray-300 mb-6"
        />
        <h2 className="text-2xl font-semibold text-gray-700 m-0 mb-4">
          No Dashboard Selected
        </h2>
        <p className="text-gray-500 mb-6 leading-relaxed">
          Your project data is ready, but you haven&apos;t selected a dashboard
          to display. Choose an existing dashboard from the dropdown above, or
          create a new one to get started.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <div className="flex items-center text-sm text-gray-600">
            <FontAwesomeIcon
              icon={faFileLines}
              className="text-blue-500 mr-2"
            />
            Select an existing dashboard
          </div>
          <div className="text-gray-400 hidden sm:block">or</div>
          <div className="flex items-center text-sm text-gray-600">
            <FontAwesomeIcon
              icon={faFileCirclePlus}
              className="text-green-500 mr-2"
            />
            Create a new dashboard
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoReportSelected
